import { Button } from "@sellar-io/components";
import { useNavigate } from "react-router";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { PRICE_TIER_EDIT } from "../../../../constants/routes";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { usePriceTierDuplicate } from "../../../../hooks/api/v2/priceTier/usePriceTierDuplicate";

export const PriceTierDuplicateDialog = ({
  active,
  onDismiss,
  priceTierName,
  priceTierId,
}: {
  active: boolean;
  onDismiss: () => void;
  priceTierName: string;
  priceTierId: number;
}) => {
  const navigate = useNavigate();

  const priceTierDuplicateMutation = usePriceTierDuplicate(priceTierId);
  const onSubmit = () => {
    priceTierDuplicateMutation.mutate(undefined, {
      onSuccess: (priceTier) =>
        navigate(PRICE_TIER_EDIT.href({ priceTierId: priceTier.id })),
    });
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`Duplicate ${priceTierName}`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        description={`Create a new price tier and populate it with a copy of the pricing, discounts, order rules and product settings from this price tier: ${priceTierName}. You can edit any of the information once duplicated.`}
      />

      <DialogContent>
        {priceTierDuplicateMutation.isError && (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(priceTierDuplicateMutation.error)?.response?.data
                .message ?? "Unknown error"
            }
          />
        )}
      </DialogContent>

      <DialogCTA>
        <Button
          loading={priceTierDuplicateMutation.isPending}
          disabled={priceTierDuplicateMutation.isPending}
          onClick={onSubmit}
        >
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
